import { gql } from '@apollo/client';

export const GET_INSIGHTS_SUMMARY = gql`
  query GetInsightsSummary($window: String) {
    getInsightsSummary(window: $window) {
      window
      weeklyRecap {
        title
        summary
        totalUpdates
        activeHobbies
        activeDays
        mostActiveHobby
        favoritesAdded
      }
      shareRecap {
        eyebrow
        storyType
        primaryHobbyId
        title
        summary
        achievement { kind label value detail }
        activeHobbyCount
        daysWithHobbies
        metrics { label value detail }
        hobbies {
          hobbyId
          hobby
          activityCount
        }
      }
      entitlementSummary {
        planKind
        unlockedHobbies
        lockedHobbies
        bundleUnlocked
      }
      recapCards {
        label
        value
        detail
        ratingValue
      }
      momentum {
        currentUpdates
        previousUpdates
        delta
        direction
        activeDays
        mostConsistentHobby
        fitnessCompletionRate
      }
      fitnessProgress {
        activeRoutines
        scheduledThisWeek
        completedThisWeek
        skippedThisWeek
        missedThisWeek
        remainingThisWeek
        adherenceRate
        previousAdherenceRate
        adherenceDelta
        nextPlanId
        nextPlanTitle
        nextPlanDayId
        nextDayTitle
        nextWeekday
        nextState
        weeklyAdherence { label value }
        weeklyMinutes { label value }
      }
      hobbyInsights {
        hobbyId
        hobby
        entries
        previousEntries
        delta
        latestTitle
        cards {
          label
          value
          detail
          ratingValue
        }
      }
      hobbyDeepDives {
        hobbyId
        hobby
        title
        summary
        entries
        locked
        dataMaturity
        atAGlance {
          label
          value
          detail
          ratingValue
        }
        consistency { label value detail ratingValue }
        charts {
          id
          title
          subtitle
          kind
          locked
          points { label value }
        }
        standouts { title subtitle value ratingValue imageUrl targetId }
        patterns { title body tone }
        nextAction { label hobbyId targetId }
      }
      lockedPreviews {
        hobbyId
        hobby
        title
        summary
        locked
      }
      notablePatterns {
        title
        body
        tone
      }
      crossHobbyPatterns {
        title
        body
        tone
      }
      trends {
        weeklyActivity {
          label
          value
        }
        hobbyDistribution {
          label
          value
        }
        dailyActivity {
          label
          value
        }
        ratingDistribution {
          label
          value
        }
      }
      chartSections {
        id
        title
        subtitle
        kind
        locked
        points {
          label
          value
        }
      }
    }
  }
`;
